if (window.location.pathname.startsWith('/renderer')) {
  import('./renderer/bootstrap');
} else {
  import('./main/bootstrap');
}
